<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Job List</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
      :new-to="{ name: 'job.create', params: { id: 0 } }"
      new-button-text="New Job"
    >
      <template slot="middle">
        <!-- <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        /> -->
      </template>
    </o-list-toolbar>
    <!-- @row-selected="onRowSelected"
      :selectable="selected.selectable" :key="selected.selectable" -->
    <b-table
      striped
      bordered
      :tbody-tr-class="row_class"
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header position-sticky"
      sticky-header="70vh"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>

      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_end_date'"
        >
          <date-display
            :value="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_start_date'"
        >
          <date-display
            :value="item.active_start_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(bob_cat)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'bob_cat'"
        >
          <div class="mb-2">
            <lookup-display
              :list="optionSupplierItemsById"
              :value="item.bob_cat"
              display-field="name"
              default-value="-"
            ></lookup-display>
          </div>
          <div class="mb-2">
            <lookup-display
              :list="optionSupplierItemsById"
              :value="item.bob_cat_2"
              display-field="name"
              default-value="-"
            ></lookup-display>
          </div>
        </o-link-cell>
      </template>
      <template slot="cell(bob_cat_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'bob_cat_date'"
        >
          <date-display
            :value="item.bob_cat_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(bob_cat_ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'bob_cat_ohs'"
        >
          <boolean-display :value="item.bob_cat_ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(comments)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'comments'"
        >
          <default-display :value="item.comments"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(concrete_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'concrete_notes'"
        >
          <default-display :value="item.concrete_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(concrete_order)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'concrete_order'"
        >
          <date-display
            :value="item.concrete_order"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(crew_supplier)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'crew_supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.crew_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(crew_leader)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'crew_leader'"
        >
          <lookup-display
            :list="optionEmployeeItemsById"
            :value="item.crew_leader"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(customer)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'customer'"
        >
          <lookup-display
            :list="optionCustomerItemsById"
            :value="item.customer"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_call_up_received)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_call_up_received'"
        >
          <date-display
            :value="item.date_call_up_received"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_sent_to_myob)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_sent_to_myob'"
        >
          <date-display
            :value="item.date_sent_to_myob"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(drain_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'drain_date'"
        >
          <date-display
            :value="item.drain_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(files)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'files'"
        >
          <default-display :value="item.files"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(inspector)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'inspector'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.inspector"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(invoices)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <p class="m-0" v-for="invoice in item.invoices">
            <date-display
              :value="invoice['date_invoiced']"
              format="DD/MM/YYYY"
            ></date-display>
          </p>
        </o-link-cell>
      </template>
      <template slot="cell(is_pier_passed)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'is_pier_passed'"
        >
          <boolean-display :value="item.is_pier_passed"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(job_location)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'job_location'"
        >
          <lookup-display
            :list="optionCodeJobLocationItemsById"
            :value="item.job_location"
            display-field="description"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(job_type)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'job_type'"
        >
          <lookup-display
            :list="optionCodeJobTypeItemsById"
            :value="item.job_type"
            display-field="description"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(lot_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'lot_no'"
        >
          <default-display :value="item.lot_no"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(m2)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'm2'"
        >
          <number-display :value="item.m2" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(no_of_piers)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'no_of_piers'"
        >
          <number-display :value="item.no_of_piers" :decimals="0" />
        </o-link-cell>
      </template>
      <template slot="cell(notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'notes'"
        >
          <default-display :value="item.notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'ohs'"
        >
          <boolean-display :value="item.ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(original_data)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'original_data'"
        >
          {{ item.original_data }}
        </o-link-cell>
      </template>
      <template slot="cell(original_job_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'original_job_number'"
        >
          <default-display :value="jobNumber(item)"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(id)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'id'"
        >
          <default-display :value="item.id"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(part_a_required)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'part_a_required'"
        >
          <boolean-display :value="item.part_a_required"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(part_a_supplier)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'part_a_supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.part_a_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_booking_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_booking_no'"
        >
          <default-display :value="item.pier_booking_no"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_date'"
        >
          <date-display
            :value="item.pier_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_inspection_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_inspection_date'"
        >
          <date-display
            :value="item.pier_inspection_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_ohs'"
        >
          <boolean-display :value="item.pier_ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(piers_crew)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'piers_crew'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.piers_crew"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(plan_provided)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'plan_provided'"
        >
          <boolean-display :value="item.plan_provided"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(pod_picked_up_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pod_picked_up_date'"
        >
          <date-display
            :value="item.pod_picked_up_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pour_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pour_date'"
        >
          <date-display
            :value="item.pour_date"
            default-value="None"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pre_slab_booked_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_booked_date'"
        >
          <date-display
            :value="item.pre_slab_booked_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pre_slab_booking_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_booking_no'"
        >
          <default-display :value="item.pre_slab_booking_no"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(pre_slab_inspection_passed)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_inspection_passed'"
        >
          <boolean-display
            :value="item.pre_slab_inspection_passed"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(pre_slab_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_notes'"
        >
          <default-display :value="item.pre_slab_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(pre_slab_passed)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_passed'"
        >
          <date-display
            :value="item.pre_slab_passed"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pump)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pump'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.pump"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(pump_ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pump_ohs'"
        >
          <boolean-display :value="item.pump_ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(purchase_order_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'purchase_order_number'"
        >
          <default-display
            :value="item.purchase_order_number"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(replaced_data)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'replaced_data'"
        >
          {{ item.replaced_data }}
        </o-link-cell>
      </template>
      <template slot="cell(rock_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'rock_date'"
        >
          <date-display
            :value="item.rock_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(rock_m2)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'rock_m2'"
        >
          <number-display :value="item.rock_m2" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(set_out_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'set_out_date'"
        >
          <date-display
            :value="item.set_out_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_address)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_address'"
        >
          <default-display :value="item.site_address"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut'"
        >
          <boolean-display :value="item.site_cut"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_crew)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_crew'"
        >
          <div class="mb-2">
            <lookup-display
              :list="optionSupplierItemsById"
              :value="item.site_cut_crew"
              display-field="name"
              default-value="-"
            ></lookup-display>
          </div>
          <div class="mb-2">
            <lookup-display
              :list="optionSupplierItemsById"
              :value="item.site_cut_operator_2"
              display-field="name"
              default-value="-"
            ></lookup-display>
          </div>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_date'"
        >
          <date-display
            :value="item.site_cut_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(site_cut_date_received)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_date_received'"
        >
          <date-display
            :value="item.site_cut_date_received"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_ohs'"
        >
          <boolean-display :value="item.site_cut_ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(site_cut_percentage_done)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_percentage_done'"
        >
          <number-display
            :value="item.site_cut_percentage_done"
            :decimals="0"
          />
        </o-link-cell>
      </template>
      <template
        slot="cell(site_cut_retaining_walls)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_retaining_walls'"
        >
          <boolean-display
            :value="item.site_cut_retaining_walls"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_spoil)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_spoil'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.site_cut_spoil"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_tipsite)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_tipsite'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.site_cut_tipsite"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_wanted_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_wanted_date'"
        >
          <date-display
            :value="item.site_cut_wanted_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(steel_booking_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_booking_number'"
        >
          <default-display :value="item.steel_booking_number"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(steel_inspection_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_inspection_date'"
        >
          <date-display
            :value="item.steel_inspection_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(steel_inspection_passed)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_inspection_passed'"
        >
          <boolean-display
            :value="item.steel_inspection_passed"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(steel_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_notes'"
        >
          <default-display :value="item.steel_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(steel_ordered)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_ordered'"
        >
          <boolean-display :value="item.steel_ordered"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(suburb)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'suburb'"
        >
          <default-display :value="item.suburb"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor'"
        >
          <lookup-display
            :list="optionSupervisorItemsById"
            :value="item.supervisor"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(termite_part_a_booking_no)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'termite_part_a_booking_no'"
        >
          <default-display
            :value="item.termite_part_a_booking_no"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(termite_part_a_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'termite_part_a_date'"
        >
          <date-display
            :value="item.termite_part_a_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(wanted_pour_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'wanted_pour_date'"
        >
          <date-display
            :value="item.wanted_pour_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'job.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style>
.strikethrough {
  text-decoration: line-through;
  color: red;
}

.strikethrough a {
  color: red;
}
</style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

import * as active from "../../../vue-ocom/utils/active.js";
import moment from "moment";
import CrewSupplierMixin from "@/mixins/CrewSupplierMixin";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("Job", "job"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("Job"),
    CreateCodeTableFetchMixin([
      "CodeJobLocation",
      "CodeJobType",
      "Customer",
      "Supplier",
      "Employee",
      "Supervisor",
    ]),
    CrewSupplierMixin(),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(schema.Job, {}) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.Job),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
        {
          name: "Completed But Not Invoiced",
          code: "completed_but_not_invoiced",
          options: { offset: 0, sort: "id" },
        },
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Invoiced",
          code: "invoiced",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Unpaid Invoices",
          code: "unpaid_invoices",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Completed",
          code: "completed",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Has no Pour Date",
          code: "no_pour_date",
          options: { offset: 0, sort: "id" },
        },
      ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
        pour_date: { label: "Pour Date" },
        original_job_number: { label: "Job No." },
        customer: { label: "Builder / Customer Name" },
        site_address: { label: "Address" },
        bob_cat: { label: "Bob Cat Person" },
        crew_supplier: { label: "Contractor" },
        invoices: { label: "Invoice (Y/N)" },
        part_a_supplier: { label: "Part A" },
        suburb: { label: "Suburb" },
        pod_picked_up_date: { label: "POD Pickup" },
      },
    };
  },
  methods: {
    jobNumber(item) {
      if (item.original_job_number) return item.original_job_number;
      else return item.id;
    },
    row_class(item) {
      var now = moment();

      if (!active.is_item_active(item, now)) return "strikethrough";
    },
  },
  computed: {
    options() {
      return {
        CodeJobLocation: {
          options: this.optionCodeJobLocationItems,
          textField: "description",
          valueField: "id",
        },
        CodeJobType: {
          options: this.optionCodeJobTypeItems,
          textField: "description",
          valueField: "id",
        },
        Customer: {
          options: this.optionCustomerItems,
          textField: "name",
          valueField: "id",
        },
        Crew: {
          options: this.optionCrewItems,
          textField: "name",
          valueField: "id",
        },
        Supplier: {
          options: this.optionSupplierItems,
          textField: "name",
          valueField: "id",
        },
        Employee: {
          options: this.optionEmployeeItems,
          textField: "name",
          valueField: "id",
        },
        Supervisor: {
          options: this.optionSupervisorItems,
          textField: "name",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "pour_date",
        "id",
        "customer",
        "site_address",
        "suburb",
        "site_cut_crew",
        "piers_crew",
        "part_a_supplier",
        "bob_cat",
        "crew_supplier",
        "pump",
        "pod_picked_up_date",
        "invoices",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>

<style>
.b-table-sticky-header > .table.b-table > thead > tr > th {
  position: sticky !important;
}
</style>
